/*
 * UR MARK — INFINITE SCROLL FOR COLLECTION GRIDS
 *
 * Watches for [data-infinite-scroll] wrappers (rendered by snippets/pagination.liquid
 * when infinite_scroll: true is passed in). When the sentinel near the bottom of the
 * grid enters the viewport, fetches the next page and appends its <li> items to the
 * current #product-grid, then swaps in that page's pagination-wrapper so scrolling
 * continues to chain page after page.
 *
 * Graceful by design:
 * - No JS / fetch failure -> the real <a> links in the nav still work normally.
 * - Filtering (facets.js) replaces #product-grid via history.pushState, which does not
 *   reload this script, so each newly rendered pagination-wrapper is re-observed via
 *   a MutationObserver rather than a one-time init.
 */
(function () {
  'use strict';

  var observedSentinels = new WeakSet();
  var io = null;

  function getIO() {
    if (io) return io;
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextPage(entry.target);
          }
        });
      },
      { rootMargin: '600px 0px 600px 0px' }
    );
    return io;
  }

  function loadNextPage(sentinel) {
    var wrapper = sentinel.closest('[data-infinite-scroll]');
    if (!wrapper) return;

    var hasNext = wrapper.getAttribute('data-has-next') === 'true';
    var nextUrl = wrapper.getAttribute('data-next-url');
    if (!hasNext || !nextUrl || wrapper.getAttribute('data-loading') === 'true') return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    wrapper.setAttribute('data-loading', 'true');
    getIO().unobserve(sentinel);

    var statusEl = wrapper.querySelector('[data-infinite-scroll-status]');
    if (statusEl) statusEl.hidden = false;

    fetch(nextUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Infinite scroll fetch failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var newWrapper = doc.querySelector('[data-infinite-scroll]');

        if (newGrid) {
          Array.prototype.forEach.call(newGrid.children, function (item) {
            grid.appendChild(item);
          });
        }

        if (statusEl) statusEl.hidden = true;

        if (newWrapper) {
          wrapper.replaceWith(newWrapper);
          observeWrapper(newWrapper);
        } else {
          wrapper.remove();
        }
      })
      .catch(function (err) {
        // Leave the real pagination link in place as a fallback — don't hide it on error.
        if (statusEl) statusEl.hidden = true;
        wrapper.removeAttribute('data-loading');
        console.error('[UrMark infinite scroll]', err);
      });
  }

  function observeWrapper(wrapper) {
    var sentinel = wrapper.querySelector('[data-infinite-scroll-sentinel]');
    var hasNext = wrapper.getAttribute('data-has-next') === 'true';
    if (!sentinel || !hasNext || observedSentinels.has(sentinel)) return;
    observedSentinels.add(sentinel);
    getIO().observe(sentinel);
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-infinite-scroll]').forEach(observeWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Re-scan after facet filtering swaps the grid in via AJAX.
  document.addEventListener('facet:updated', function () { scan(); });

  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && window.MutationObserver) {
    new MutationObserver(function () { scan(gridContainer); }).observe(gridContainer, {
      childList: true,
      subtree: true
    });
  }
})();
